<template>
	<div class="content">
		<el-row>
			<el-col :xs="10" :sm="18" :md="4" :lg="4" :xl="4">
				<div class="logo" @click="SelectHome()">
					<img src="../assets/home-image/homeloge.png" />
				</div>
			</el-col>
			<el-col :xs="14" :sm="6" :md="16" :lg="16" :xl="16">
				<div class="home-content">
					<el-menu class="el-menu-demo" mode="horizontal">
						<el-menu-item index="first" @click="SelectHome()">首页</el-menu-item>
						<el-menu-item index="second" @click="SelectActivity()">最新活动</el-menu-item>
						<el-menu-item index="third" @click="SelectProduct()">产品及服务</el-menu-item>
						<el-menu-item index="fourth" @click="SelectTeam()">合作方案</el-menu-item>
						<el-menu-item index="five" @click="SelectAbout()">关于我们</el-menu-item>
						<el-menu-item index="six" @click="SelectNews()">新闻中心</el-menu-item>
						<el-menu-item index="seven" @click="SelectContact()">联系我们</el-menu-item>
					</el-menu>
				</div>
			</el-col>
			<div class="Homeheader-bntbox">
				<el-button class="Homeheader-bnt" @click="showbnt()">
					<i class="el-icon-s-fold"></i>
				</el-button>
			</div>
			<el-col :md="4" :lg="4" :xl="4">
				<div class="phone-namber">
					<img src="../assets/home-image/phonenumber.png" />
					<span>400-2620-268</span>
				</div>
			</el-col>
		</el-row>
		<div class="phone-duan" v-if="show">
			<el-menu class="el-menu-phone" mode="horizontal">
				<el-menu-item index="first" @click="SelectHome()">首页</el-menu-item>
				<el-menu-item index="second" @click="SelectActivity()">最新活动</el-menu-item>
				<el-menu-item index="third" @click="SelectProduct()">产品及服务</el-menu-item>
				<el-menu-item index="fourth" @click="SelectTeam()">合作方案</el-menu-item>
				<el-menu-item index="five" @click="SelectAbout()">关于我们</el-menu-item>
				<el-menu-item index="six" @click="SelectNews()">新闻中心</el-menu-item>
				<el-menu-item index="seven" @click="SelectContact()">联系我们</el-menu-item>
			</el-menu>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'HeaderNav',
		data() {
			return {
				activeIndex: '1',
				show: false,
			}
		},
		methods: {
			/* 点击显示隐藏头部导航条 */
			showbnt() {
				this.show = !this.show
			},
			/* 首页跳转 */
			SelectHome() {
				this.$router.push({
					path: '/Home'
				})
        this.show = !this.show
			},
			/* 最新活动 */
			SelectActivity() {
				this.$router.push({
					path: '/Latevents'
				})
        this.show = !this.show
			},
			/* 产品及服务 */
			SelectProduct() {
				this.$router.push({
					path: '/Productservices'
				})
        this.show = !this.show
			},
			/* 合作方案 */
			SelectTeam() {
				this.$router.push({
					path: '/Cooperaprog'
				})
        this.show = !this.show
			},
			/* 关于我们 */
			SelectAbout() {
				this.$router.push({
					path: '/Aboutus'
				})
        this.show = !this.show
			},
			/* 点击跳转新闻中心 */
			SelectNews() {
				console.log(this.$router)
				this.$router.push({
					name: 'NewsCenter'
				})
        this.show = !this.show
			},
			/* 联系我们 */
			SelectContact() {
				this.$router.push({
					path: '/Contactus'
				})
        this.show = !this.show
			}
		}
	}
</script>

<style>
	body,
	html {
		padding: 0;
		margin: 0
	}

	.logo {
		height: 3.125rem;
		line-height: 3.125rem;
		margin: 1.1875rem 3.125rem
	}

	.logo img {
		width: 9.375rem;
		height: 2rem;
		padding-top: .625rem
	}

	.home-content {
		margin: 0 auto;
		padding-top: 0;
		width: 100%;
		font-size: 1rem;
		color: #333;
		overflow: auto;
		text-align: center !important;
		margin-top: 1.25rem !important
	}

	.home-content .el-menu--horizontal>.el-menu-item {
		height: 68px
	}

	.phone-namber {
		height: 2.25rem;
		text-align: center;
		font-size: 24px;
		color: #333;
		margin-top: 2.1rem
	}

	.phone-namber img {
		width: 1.689375rem;
		height: 1.3725rem;
		padding-right: .625rem;
		text-align: center
	}

	.home-content.el-menu-item {
		height: 4.375rem !important;
		color: #333 !important;
		padding: 0 1.25rem;
		margin: 0 auto
	}

	.el-menu {
		margin: 0 auto !important
	}

	.el-menu-item.is-active {
		color: #42b983 !important;
		border-bottom: .125rem solid #42b983 !important
	}

	.el-menu.el-menu--horizontal {
		border-bottom: none !important
	}

	.Homeheader-bnt {
		padding: 0 !important;
		float: right;
		margin-right: 1.25rem !important;
		margin-top: 1.25rem !important
	}

	.Homeheader-bnt i {
		font-size: 2rem
	}


	/* 当屏幕小于992px时，pc端的导航条隐藏掉 */
	@media screen and (max-width:62rem) {
		.home-content,
		.phone-namber {
			display: none
		}

		.logo {
			width: 100%;
			height: 2rem;
			margin: 1.25rem !important;
			line-height: 2rem
		}

		.logo img {
			width: 9.375rem;
			height: 2rem;
			text-align: center
		}
	}
	/* 当屏幕大于992px时，移动端的导航条隐藏掉 */
	@media screen and (min-width: 62rem) {
		.Homeheader-bntbox,
		.phone-duan {
			display: none
		}

		.el-menu-phone .el-menu-item.is-active {
			color: #42b983 !important;
			border: none !important;
			background-color: rgba(0, 0, 0, .1) !important
		}

		.content .el-row {
			width: 100%;
			min-width: 118rem;
			max-width: 100%
		}
	}

	/* 手机端时候的导航条 */
	.phone-duan {
		width: 100%;
		overflow: auto;
		position: absolute !important;
		z-index: 9999;
		background: hsla(0, 0%, 100%, .1) !important
	}

	.el-menu-phone .el-menu-item {
		width: 100%;
		text-align: center
	}

	.el-menu-phone .el-menu-item.is-active {
		color: #42b983 !important;
		border: none !important;
		background-color: rgba(0, 0, 0, .1) !important
	}

	.Homeheader-bntbox .el-button {
		width: auto
	}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue